/**
 * STORY-520: the provider health the backend reports on
 * GET /api/llm/providers/available (`health`). Parsed defensively — an older
 * backend sends nothing, and anything that is not the closed shape is
 * dropped rather than shown.
 */
import type { ProviderHealth } from '@/types';

const KINDS = new Set(['provider_error', 'timeout']);

function finiteOrNull(v: unknown): number | null {
  return typeof v === 'number' && Number.isFinite(v) ? v : null;
}

export function parseProviderHealth(raw: unknown): ProviderHealth | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const r = raw as Record<string, unknown>;
  if (r.state !== 'ok' && r.state !== 'failing') return undefined;
  const kind = typeof r.last_error_kind === 'string' && KINDS.has(r.last_error_kind)
    ? (r.last_error_kind as ProviderHealth['last_error_kind'])
    : null;
  return {
    state: r.state,
    consecutive_failures: finiteOrNull(r.consecutive_failures) ?? 0,
    last_error_kind: kind,
    failing_since: finiteOrNull(r.failing_since),
    last_ok_at: finiteOrNull(r.last_ok_at),
  };
}

export function isProviderFailing(health: ProviderHealth | undefined): boolean {
  return health?.state === 'failing';
}
